import { Contact } from "../contact";
import { Explore } from "../explore";
import styles from "./index.module.scss";

export const Desktop = () => {
    return (
        <div className={styles.desktop}>
            <div className={styles.content}>
                <Contact />
                <Explore />
            </div>
            <span className={styles.logo}>Timothée Dumas</span>
        </div>
    );
};